<template>
    <div class="MyOrder">
        <div class="MyOrderBox">
            <!-- 查询 -->
            <el-form :inline="true" :model="OtherAuthorizeForm" style="text-align: left;margin-top: 20px;" class="demo-form-inline">
                <el-form-item>
                    <el-button :type="Traem ? 'primary' : 'info'" :display="!Traem" :disabled="!Traem" @click="handleAuthReport" icon="el-icon-plus">{{ Ytxfont }}</el-button>
                </el-form-item>
            </el-form>
		  <!-- 查询 -->
		  <el-form :inline="true" :model="OtherAuthorizeForm" style="text-align: left;" class="demo-form-inline">
			<el-form-item label="报告编号：" style="margin-right: 30px;">
			  <el-input v-model="OtherAuthorizeForm.reportNo" ></el-input>
			</el-form-item>
			<el-form-item label="报告日期：" style="margin-right: 30px;">
			  <el-date-picker
				  v-model="date"
				  @change="handleChangeDate"
				  type="daterange"
				  value-format="yyyy-MM-dd"
				  range-separator="至"
				  start-placeholder="开始日期"
				  end-placeholder="结束日期"
				  align="right"
				  :picker-options="pickerOptions"
				  unlink-panels></el-date-picker>
			</el-form-item>
			<el-form-item>
			  <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜 索</el-button>
			</el-form-item>
		  </el-form>
            <!-- table -->
            <el-table :data="MyOrderList" :header-cell-style="HeaderCellStyle" :cell-style="CellStyle" v-loading="listLoading"  border style="width: 100%;">
                <el-table-column prop="reportNo" label="报告编号" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column prop="requestAuthorizeTime" label="请求授权时间" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="stateName" label="授权状态" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="authorizeTime" label="授权日期" min-width="20%" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="操作" min-width="20%" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <div style="margin-bottom: 12px;" v-if="scope.row.state === 5">
                            <el-button type="primary" size="small" style="background-color: #409eff; border-color: #409eff;" @click="handleMsgShow(scope.row)">输入验证码</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <!--  v-loading="listLoading" -->
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page="OtherAuthorizeForm.currentPage"
                    background
                    :page-size="OtherAuthorizeForm.pageSize"
                    layout="total, prev, pager, next"
                    prev-text="上一页"
                    next-text="下一页"
                    :total="total">
                </el-pagination>
            </div>
        </div>
	  <el-dialog
		  title="请求将其他公司的检测报告授权给海尔SQM"
		  :visible.sync="dialogVisible"
		  width="30%"
		  :before-close="handleOtherCode">
		<span>
		   <el-form  ref="Form"  label-width="100px">
			 <el-form-item label="报告编号：" prop="reportNo">
			   <el-col :span="18">
              		<el-input size="small" v-model="reportNo" placeholder="请输入其他公司的报告编号"></el-input>
			   </el-col>
             </el-form-item>
		   </el-form>
		</span>
		<span slot="footer" class="dialog-footer">
		<el-button @click="handleOtherCode">取 消</el-button>
		<el-button type="primary" @click="reportAuthorizeOther">请求授权</el-button>
	  </span>
	  </el-dialog>
	  <el-dialog
		  title="授权验证码"
		  :visible.sync="dialogVisible2"
		  width="30%"
		  :before-close="handleMsgCode">
		<span>
		  <el-form  ref="Form"  label-width="100px">
			 <el-form-item label="验证码：" prop="goodsName">
			   <el-col :span="18">
				  <el-input size="small" v-model="verifyCode" placeholder="请输入授权验证码"></el-input>
			   </el-col>
          </el-form-item>
		   </el-form></span>
		<span slot="footer" class="dialog-footer">
		  <el-button @click="handleMsgCode">取 消</el-button>
		  <el-button type="primary" @click="reportAuthorizeOtherByMsg">确 定</el-button>
		</span>
	  </el-dialog>
    </div>
  
  
</template>

<script>
import * as API from '@/api/authorize';
import { getCommonToken } from '@/utils/auth';
export default {
    name: 'OtherAuthorize',
    components: {
    
    },
    data() {
        return {
			OtherAuthorizeForm: {
                pageSize: 10,
                currentPage: 1
            },
            StatusOptions: [
                { label: '全 部', value: '' },
                { label: '待支付', value: '10' },
                { label: '处理中', value: '15' },
                { label: '待发货', value: '20' },
                { label: '已发货', value: '25' },
                { label: '已完成', value: '30' },
                { label: '已取消', value: '50' }
            ],
            // 时间
            date: [],
            // tableList
            MyOrderList: [],
            total: 0,
            listLoading: false,
		    dialogVisible2:false,
		    dialogVisible:false,
			Traem: true,
			Ytxfont: "申请授权其他公司报告",
		    reportNo:'',
		    verifyCode:'',
		    reportId:0,
		    resId:0
        }
    },
    methods: {
        // 查询
        handleSearch() {
            this.GetList();
        },
		handleAuthReport(){
            this.Yanma()
			this.dialogVisible = true
		},
		handleMsgShow(row){
		  this.dialogVisible2 = true
		  this.resId = row.reportId
		},
		handleMsgCode(){
		  this.dialogVisible2 = false
		  this.resId = 0
		},
		handleOtherCode(){
		  this.dialogVisible = false
		  this.reportNo = ''
		},
        // 授权其他公司
	    reportAuthorizeOther() {
          if(this.reportNo === ''){
			this.$message({ type: 'warning', message: '请输入正确的报告编号'});
            return;
		  }
		  API.reportAuthorizeOther(this.reportNo).then(res => {
			if (res.code === 20000) {
			  this.$message({ type: 'success', message: '授权申请发送成功，请稍后...'});
			  this.GetList();
			  this.handleOtherCode();
			}
		  })
        },
        // 短信验证码
	    reportAuthorizeOtherByMsg() {
		  API.reportAuthorizeOtherByMsg(this.verifyCode,this.resId).then(res => {
			if (res.code === 20000) {
			  this.$message({ type: 'success', message: '短信授权码发送成功!'});
			  this.GetList();
			  this.handleMsgCode();
			}
		  })
        },
		// 报告时间
		handleChangeDate(val) {
		  if(val) {
			this.$set(this.OtherAuthorizeForm, 'reportStarttime', val[0] + ' 00:00:00');
			this.$set(this.OtherAuthorizeForm, 'reportEndtime', val[1]+ ' 23:59:59');
		  } else {
			this.$set(this.OtherAuthorizeForm, 'reportStarttime', null);
			this.$set(this.OtherAuthorizeForm, 'reportEndtime', null);
		  }
		},
        // 分页改变
        handleCurrentChange(val) {
            this.OtherAuthorizeForm.currentPage = val;
            this.GetList();
        },
        // 获取报告列表
        GetList() {
            this.listLoading = false;
            this.$set(this.OtherAuthorizeForm, "xdkh", getCommonToken("MOBILE"));
            API.getOtherReportList(this.OtherAuthorizeForm).then(res => {
                this.listLoading = false;
                if(res.code === 20000) {
                    this.MyOrderList = res.data.datas;
                    this.total = res.data.totalRecord;
                }
            }).catch(() => {
                this.listLoading = false;
            });
        },
        // 0  创建  10 待支付  15  处理中   20 待发货  25 已发货  30 已完成  50 已取消
        GetStatus(status) {
            let str;
            switch(status) {
                case 0:
                    str = "创建";
                    break;
                case 10:
                    str = "待支付";
                    break;
                case 15:
                    str = "处理中";
                    break;
                case 20:
                    str = "待发货";
                    break;
                case 25:
                    str = "已发货";
                    break;
                case 30:
                    str = "已完成";
                    break;
                case 50:
                    str = "已取消";
                    break;
            }
            return str;
        },
        // 表头
        HeaderCellStyle () {
            // console.log(row, column, rowIndex, columnIndex);
            return 'text-align: center; color: #ffffff; background: #3880ca;';
        },
        // 单元格
        CellStyle () {
            // console.log(row, column, rowIndex, columnIndex);
            return 'text-align: center; color: #000000;';
        },
		// 倒计时
		Yanma() {
          console.info(this.Traem)
		  if (this.Traem) {
			let langtime = 15;
			let than = this;
			this.Traem = false;
			than.Ytxfont = `${langtime} 秒后可以重新授权`;
			let a = setInterval(() => {
			  if (langtime === 0) {
				than.Traem = true;
				than.Ytxfont = "申请授权其他公司报告";
				clearInterval(a);
			  } else {
				than.Traem = false;
				langtime--;
				console.info(langtime)
				than.Ytxfont = `${langtime} 秒后可以重新授权`;
			  }
			}, 1000);
		  } else {
			console.log("不能点了")
		  }
		}
    },
    mounted() {
        console.log("Mobile", getCommonToken("MOBILE"))
        this.GetList();
    }
}
</script>

<style scoped>
.MyOrder {
    margin-top: 12px;
    overflow: hidden;
    margin-bottom: 200px;
}
.MyOrder .MyOrderBox {
    width: 100%;
    margin: 0 auto;
}
.MyOrder .MyOrderBox .Img {
    margin-top: 60px;
    overflow: hidden;
    text-align: left;
    margin-bottom: 60px;
}
.MyOrder .MyOrderBox /deep/ .el-form--inline .el-form-item__label {
    font-weight: 600;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox {
    overflow: hidden;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .image {
    width: 58px;
    height: 58px;
    float: left;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .image img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info {
    float: left;
    width: 292px;
    overflow: hidden;
    text-align: left;
    margin-left: 16px;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info .title {
    font-weight: 600;
    margin-bottom: 10px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.MyOrder .MyOrderBox /deep/ .el-table .GoodsBox .info .desc {
    font-size: 12px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.MyOrder .MyOrderBox .page {
    text-align: right;
    margin-top: 20px;
}
.MyOrder .MyOrderBox .page  /deep/ .el-pagination.is-background .btn-next, 
.MyOrder .MyOrderBox .page  /deep/ .el-pagination.is-background .btn-prev {
  padding: 0 5px;
}
</style>